/*!
 * Date: 2026/1/28
 * <p>
 * Copyright (c) 2026, zhaotao All Rights Reserved.
 *
 * @author zhaotao
 */
const features = [
  'PDF导读',
  'PDF阅读理解',
  'PDF比较阅读',
  '概念解析',
  '概念关系解析',
  '隐性知识链路',
  '创意探索（扩展搜索）',
  '段落翻译',
  '阅读轨迹回顾',
  '融会贯通',
  'DeepSeek接口',
  '实时在线搜索',
  '个人积累文献导读',
  'Word文献精读',
  '搜索概要',
  '学术综述',
  '兴趣解析',
  '多源大语言模型接口',
  '自定义大语言模型接口',
  '读写融合',
  'PubMed',
  '实时搜索导读',
  '图文聚焦导读',
];

function copy(isAccept) {
  return features.map((feature, index) => {
    return {
      name: feature,
      checked: isAccept(feature, index)
    }
  })
}

const versions = [
  {
    name: '个人基础版',
    amount: '免费',
    desc: 'Email注册<br/>（永久免费）',
    features: copy((feature, index) => {
      return index < 11;
    })
  },
  {
    name: 'Plus 会员版',
    badge: '推荐',
    amount: '¥199/年',
    desc: '（院校师生5折）',
    features: copy((feature, index) => {
      return index < 20;
    })
  },
  {
    name: '医学专业版',
    amount: '¥699/年',
    features: copy((feature, index) => {
      return true;
    })
  },
];

export const Prices = {
  copy,
  versions,
  features,
}
